"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var token_1 = __importDefault(require("./token"));
var serialize_1 = require("./utils/serialize");
exports.requestPKCEToken = function (options) {
    return fetch(options.url + "/oauth/token", {
        body: serialize_1.stringify({
            grant_type: 'authorization_code',
            code: options.code,
            client_id: options.client_id,
            redirect_uri: options.redirect_url,
            state: options.state,
            code_verifier: options.code_verifier,
        }),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
        },
        method: 'POST',
    })
        .then(function (res) {
        if (res.ok) {
            return res.json();
        }
        return res
            .json()
            .then(function (json) {
            throw new Error(res.status + " " + res.statusText + ": " + json.error_description);
        })
            .catch(function () {
            throw new Error(res.status + " " + res.statusText);
        });
    })
        .then(function (json) { return new token_1.default(json); });
};
//# sourceMappingURL=pkceToken.js.map